// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"183":"6fa76568","506":"4cb0cf48","756":"03c41866"}[chunkId] + ".chunk.css";
};